import { useState } from 'react'

export function useMembershipSelection() {
	const [selectedMemberships, setSelectedMemberships] = useState(new Set())

	const handleSelectAll = (checked, membershipsData) => {
		if (checked) {
			const allIds = new Set(membershipsData.map(m => m._id))
			setSelectedMemberships(allIds)
		} else {
			setSelectedMemberships(new Set())
		}
	}

	const handleSelectMembership = (membershipId, checked) => {
		const newSelection = new Set(selectedMemberships)
		if (checked) {
			newSelection.add(membershipId)
		} else {
			newSelection.delete(membershipId)
		}
		setSelectedMemberships(newSelection)
	}

	const clearSelection = () => {
		setSelectedMemberships(new Set())
	}

	const getSelectionState = membershipsData => {
		const isAllSelected = membershipsData.length > 0 && selectedMemberships.size === membershipsData.length
		const isIndeterminate = selectedMemberships.size > 0 && selectedMemberships.size < membershipsData.length

		return { isAllSelected, isIndeterminate }
	}

	return {
		selectedMemberships,
		handleSelectAll,
		handleSelectMembership,
		clearSelection,
		getSelectionState,
	}
}
